"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignUpStage = exports.EmailChasersStatus = exports.UserRole = exports.UserStatus = void 0;

var common_1 = require("./common");

var UserStatus;

(function (UserStatus) {
  UserStatus["ACTIVE"] = "active";
  UserStatus["BLOCKED"] = "blocked";
  UserStatus["BANNED"] = "banned";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));

var UserRole;

(function (UserRole) {
  UserRole["ADMIN"] = "admin";
  UserRole["DEVELOPER"] = "developer";
  UserRole["VIEW_ONLY"] = "view_only";
})(UserRole = exports.UserRole || (exports.UserRole = {}));

var EmailChasersStatus;

(function (EmailChasersStatus) {
  EmailChasersStatus["NOT_STARTED"] = "not_started";
  EmailChasersStatus["STARTED"] = "started";
  EmailChasersStatus["FINISHED"] = "finished";
  EmailChasersStatus["STOPPED"] = "stopped";
})(EmailChasersStatus = exports.EmailChasersStatus || (exports.EmailChasersStatus = {}));

var SignUpStage;

(function (SignUpStage) {
  SignUpStage["ACCOUNT_CREATED"] = "account_created";
  SignUpStage["ADDITIONAL_INFORMATION"] = "additional_information_added";
  SignUpStage["COMPANY_CREATED"] = "company_created";
  SignUpStage["ID_VERIFICATION"] = "id_verification";
  SignUpStage["BANK_ACCOUNT_CONNECTION"] = "bank_account_connection";
  SignUpStage["FULLY_REGISTERED"] = "fully_registered";
})(SignUpStage = exports.SignUpStage || (exports.SignUpStage = {}));